import { httpClient } from '@/services/http/httpClient'
import type { UserStatus } from '../types'

type Params = {
  usersIds: string[]
  status: UserStatus
}

export type BulkUpdateStatusResponse = { updated: number }

export async function bulkUpdateStatus({
  usersIds,
  status,
}: Params): Promise<BulkUpdateStatusResponse> {
  const { data } = await httpClient.post<BulkUpdateStatusResponse>(
    '/users/bulk-status',
    { usersIds, status },
  )
  return data
}
